import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

import { LazySectionWrapperModule } from '../lazy-section-wrapper/lazy-section-wrapper.module';
import { HoverPopoverDirective } from './hover-popover.directive';
import { PopoverContainerComponent } from './popover-container.component';

/**
 * Encapsulated feature module providing reusable hover popovers with lazy template
 * instantiation and dynamic async code-splitting support powered by LazySectionWrapperModule.
 */
@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    LazySectionWrapperModule
  ],
  declarations: [
    HoverPopoverDirective,
    PopoverContainerComponent
  ],
  exports: [
    HoverPopoverDirective,
    PopoverContainerComponent,
    OverlayModule,
    PortalModule
  ],
  entryComponents: [
    PopoverContainerComponent
  ]
})
export class LazyPopoverModule {}
